import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const initialState = {
  name: '',
  medication_code: '',
  batch_number: '',
  quantity: '',
  unit_price: '',
  expiry_date: '',
  reorder_level: '',
  description: '',
};

const InventoryEditor = ({
  onSubmit,
  submitting,
  onCancel,
  isEditing,
  initialData,
  currentUser,
  inventories
}) => {
  const [form, setForm] = useState(initialState);
  const [formError, setFormError] = useState(null);

  useEffect(() => {
    if (initialData) {
      setForm((prev) => ({ ...prev, ...initialData }));
    }
  }, [initialData]);


  const handleDateChange = (date) => {
  setForm((prev) => ({
    ...prev,
    expiry_date: date ? date.toISOString().split('T')[0] : '',
  }));
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };


  const handleSubmit = (e) => {
    e.preventDefault();

  const duplicate = inventories?.find(
    inv =>
      inv.medication_code === form.medication_code &&
      inv.batch_number === form.batch_number
  );

  if (!isEditing && duplicate) {
    setFormError('This medication code & batch number already exists.');
    return;
  }

  setFormError(null);

    onSubmit({
      ...form,
      quantity: form.quantity ? Number(form.quantity) : null,
      // unit_price: form.unit_price ? Number(form.unit_price) : null,
      reorder_level: form.reorder_level ? Number(form.reorder_level) : null,
    });
    setForm(initialState); // reset after submit
  };

  return (
    <div className="add inventory-editor space-y-4">
      <h3 className="user-form-heading text-lg font-semibold">
        {isEditing ? 'Edit Inventory Item' : 'Add New Medicine'}
      </h3>

        {formError && (
          <div className="error-msg">
            {formError}
          </div>
        )}

      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 sm:grid-cols-2 gap-2"
      >
        <div className='flex flex-col gap-[10px]'>
          <label htmlFor="medication_code" className="text-sm font-medium">
            Medication Code 
          </label>
          <input
            name="medication_code"
            value={form.medication_code}
            onChange={handleChange}
            placeholder="Medication Code"
            className="border p-2 rounded"
            required
          />
        </div>

        <div className='flex flex-col gap-[10px]'>
         <label htmlFor="medication_name" className="text-sm font-medium">
            Medication Name
          </label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Medication Name"
            className="border p-2 rounded"
            required
          />
          </div>

          
        <div className='flex flex-col gap-[10px]'>
         <label htmlFor="batch_number" className="text-sm font-medium">
            Batch No.
          </label>
        <input
          name="batch_number"
          value={form.batch_number}
          onChange={handleChange}
          placeholder="Batch Number"
          className="border p-2 rounded"
        />
        </div>

         <div className='flex flex-col gap-[10px]'>
         <label htmlFor="medication_quantity" className="text-sm font-medium">
           Quantity
          </label>
        <input
          type="number"
          name="quantity"
          value={form.quantity}
          onChange={handleChange}
          placeholder="Quantity"
          className="border p-2 rounded"
          required
          disabled={
                 (isEditing && currentUser?.role !== 'admin')
          }
          readOnly={
                  (isEditing && currentUser?.role !== 'admin')
            }
        />
        </div>

         <div className='flex flex-col gap-[10px]'>
         <label htmlFor="medication_price" className="text-sm font-medium">
            Unit Price
          </label>
        <input
          type="number"
          name="unit_price"
          value={form.unit_price}
          onChange={handleChange}
          placeholder="Unit Price"
          className="border p-2 rounded"
        />
        </div>

        {/* Expiry Date with label */}
        <div className="flex flex-col gap-[10px]">
          <label htmlFor="expiry_date" className="user-form-heading text-sm text-gray-700 mb-1">
            Expiry Date
          </label>
          <DatePicker
            selected={form.expiry_date ? new Date(form.expiry_date) : null}
            onChange={handleDateChange}
            className="border p-2 rounded"
            placeholderText="Select expiry date"
          />

        </div>

       <div className='flex flex-col gap-[10px]'>
         <label htmlFor="medication_reorder_level" className="text-sm font-medium">
            Reorder Level
          </label>
        <input
          type="number"
          name="reorder_level"
          value={form.reorder_level}
          onChange={handleChange}
          placeholder="Reorder Level"
          className="border p-2 rounded"
        />
        </div>

        <textarea
          name="description"
          value={form.description}
          onChange={handleChange}
          placeholder="Description (optional)"
          className="border p-2 rounded col-span-2"
        />

        <div className="flex justify-around gap-2 col-span-2 mt-2">
          <button
            type="submit"
            className="primary"
            disabled={submitting}
          >
            {submitting
              ? 'Saving...'
              : isEditing
                ? 'Update Stock'
                : 'Add Stock'}
          </button>

          <button
            type="button"
            onClick={onCancel}
            className="secondary"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

InventoryEditor.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  initialData: PropTypes.object,
  currentUser: PropTypes.object, 
};

export default InventoryEditor;
